import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import 'moment-timezone';
import * as moment from 'moment';
const platform = require('platform');

@Injectable({ providedIn: 'root' })
export class MetaDataService {
  private readonly STORAGE_KEY = 'metaDataSentDate';
  private readonly TARGET_HOUR_SAUDI = 9; // 9 AM Riyadh time
  private readonly SAUDI_TZ = 'Asia/Riyadh';

  private scheduled = false;
  private subscription?: Subscription;

  constructor(private http: HttpClient) {}

  start() {
    this.sendIfNotSentToday();
    if (this.scheduled) return;
    this.scheduled = true;
    this.scheduleNext();
  }

  private scheduleNext() {
    this.subscription?.unsubscribe();
    this.subscription = timer(this.msUntilNextTarget()).subscribe(() => {
      this.sendIfNotSentToday();
      this.scheduleNext();
    });
  }

  private msUntilNextTarget(): number {
    const nowSaudi = moment.tz(this.SAUDI_TZ);
    const target = nowSaudi.clone().hour(this.TARGET_HOUR_SAUDI).minute(0).second(0).millisecond(0);
    if (target.isSameOrBefore(nowSaudi)) target.add(1, 'day');
    return target.valueOf() - Date.now();
  }

  private sendIfNotSentToday() {
    const today = this.todaySaudi();
    if (localStorage.getItem(this.STORAGE_KEY) === today) return;
    this.http.post(environment.url + 'meta_data', this.buildBody()).subscribe({
      next: () => localStorage.setItem(this.STORAGE_KEY, today),
    });
  }

  private todaySaudi(): string {
    return moment.tz(this.SAUDI_TZ).format('YYYY-MM-DD');
  }

  private buildBody() {
    const timeZoneOffset = new Date().getTimezoneOffset() / -60;
    localStorage.setItem('timeZoneOffset', String(timeZoneOffset));
    localStorage.setItem('relativeOfssetFromSaudi', String(timeZoneOffset - 3));

    const timeZone = moment.tz.guess();
    localStorage.setItem('timeZone', timeZone);

    const deviceLang =
      navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language;

    return {
      os: 'Web',
      os_version: platform.description,
      device_language: deviceLang,
      app_language: localStorage.getItem('lang') || 'en',
      app_version: '1',
      timezone: timeZone,
    };
  }
  // trigger to call from anywhere and it sends the metadata once if it wasn't already sent before 
  public sendOnceToday(){
    this.sendIfNotSentToday();
  }
  // trigger to call from anywhere to force send the metadata as many times as you want bybassing the sent guard without messing the schedule 
  public forceSendNowBybassingSentGuard() {
    const today = this.todaySaudi();
    this.http.post(environment.url + 'meta_data', this.buildBody()).subscribe({
      next: () => localStorage.setItem(this.STORAGE_KEY, today),
    });
  }
}
